import React from 'react';

import { Loading } from '@/components';
import { TFunction } from 'next-i18next';
import { Product } from '@/features/products/shared';
import { ProductLoop, ProductLoopLoading } from '@/components/loop/ProductLoop';
type ListMainPartialProps = {
  edges: Product[];
  isLoading: boolean;
  t: TFunction;
  catCode: string;
};

const ItemPartial = ({ edges, isLoading, catCode, t }: ListMainPartialProps) => {
  console.log(catCode);
  if (isLoading)
    return (
      <div className="tw-grid tw-grid-cols-2 md:tw-grid-cols-4 tw-gap-x-2 tw-gap-y-4 md:tw-gap-x-4  ">
        {Array(18)
          .fill(1)
          .map((p, index) => {
            return <ProductLoopLoading key={`loading-${index}`} />;
          })}
      </div>
    );
  return (
    <div className="tw-grid tw-grid-cols-2 md:tw-grid-cols-4 tw-gap-x-2 tw-gap-y-4 md:tw-gap-x-4  ">
      {edges.map((p) => {
        return <ProductLoop p={p} t={t} catCode={catCode} key={p.product_code} />;
      })}
    </div>
  );
};

export default ItemPartial;
